import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { combineAll, DcBaseComponent } from '@datachain/ui-sdk/common';
import {
	AppModalService,
	ModalData,
} from '@datachain/ui-sdk/components/app-modal';
import { Observable } from 'rxjs';

import { DcIcons } from '../../../ui/app-dc.icons';

export enum EntityAction {
	Persist = 'persist',
	Repersist = 'repersist',
	Depersist = 'depersist',
	Delete = 'delete',
	CreateDatablock = 'create-datablock',
}

export interface IEntityActionModalData {
	entityId: number | Array<number>;
	element: string;
	action: EntityAction;
}
@Component({
	selector: 'app-entity-action-popup',
	templateUrl: './entity-action-popup.component.html',
	styleUrls: ['./entity-action-popup.component.scss'],
})
export class EntityActionPopupComponent<
	T extends IEntityActionModalData
> extends DcBaseComponent {
	public readonly Icons = DcIcons;
	public vo$: Observable<{
		element: string;
		entityId: number | Array<number>;
		isMultipleElement: boolean;
		action: EntityAction;
	}>;
	public confirmDeletion = false;

	protected readonly DcIcons = DcIcons;
	protected readonly EntityAction = EntityAction;
	public constructor(
		private readonly modalService: AppModalService,
		@Inject(MAT_DIALOG_DATA) public readonly modalData: ModalData & T
	) {
		super();
		this.cmpId = 'entity-action';

		this.vo$ = combineAll({
			element: this.modalData.element,
			isMultipleElement:
				Array.isArray(this.modalData.entityId) && this.modalData.element === '',
			entityId: this.modalData.entityId,
			action: this.modalData.action,
		});
	}

	public confirmAction(): void {
		this.modalService.closeActiveModal({
			shouldLaunch: true,
		});
	}
}
